const { tokenBaseURL, programIdBaseURL, client_secret, client_id } =
  window.BlueRhinoConfig;

// --- Cookie Helpers ---
function setCookie(name, value, seconds) {
  const expires = new Date(Date.now() + seconds * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value,
  )}; expires=${expires}; path=/`;
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? decodeURIComponent(match[2]) : null;
}

function deleteCookie(name) {
  document.cookie = `${name}=; Max-Age=0; path=/`;
}

// --- Token Handling ---
async function requestNewToken() {
  const headers = new Headers();
  headers.append('Content-Type', 'application/x-www-form-urlencoded');

  const body = new URLSearchParams();
  body.append('grant_type', 'client_credentials');
  body.append('scope', 'brhd.Create');
  body.append('client_id', client_id);
  body.append('client_secret', client_secret);

  const response = await fetch(
    `${tokenBaseURL}/Security/IDS4Server/connect/token`,
    { method: 'POST', headers, body },
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error_description || 'Failed to retrieve token.');
  }

  // Save token + expiry in cookies
  setCookie('access_token', data.access_token, data.expires_in || 3600);
  return data.access_token;
}

export async function getToken() {
  let token = getCookie('access_token');

  if (!token) {
    // No token or expired → request a new one
    token = await requestNewToken();
  }

  return token;
}

export async function fetchProgramAreas(zipcode) {
  const token = await getToken();

  const headers = new Headers();
  headers.append('Authorization', `Bearer ${token}`);

  const response = await fetch(
    `${programIdBaseURL}/BR/HomeDelivery/ProgramAreas?zipcode=${zipcode}`,
    { method: 'GET', headers },
  );

  const result = await response.json();
  if (!response.ok) {
    // If 401 → token likely expired mid-request → retry once
    if (response.status === 401) {
      deleteCookie('access_token');
      const newToken = await requestNewToken();
      headers.set('Authorization', `Bearer ${newToken}`);
      const retryResponse = await fetch(
        `${programIdBaseURL}/BR/HomeDelivery/ProgramAreas?zipcode=${zipcode}`,
        { method: 'GET', headers },
      );
      return await retryResponse.json();
    }

    throw new Error(result.message || 'Failed to fetch program areas.');
  }

  return result;
}
